<template>
  <div class="tip-box">
    <img  src="https://resource.rcclchina.com.cn/cruiseDetail/pc/booking_pay/bookingIcon.png" alt="">
    <span>支持订金预订¥1000/人起</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.tip-box{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  background: #FFF1DC;
  border-radius: 12px;
  padding: 0 12px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-top: 12px;
}

.tip-box > img{
  width: 14.4px;
  height: 14.4px;
  margin-right: 4px;
}
.tip-box > span{
  font-weight: 500;
  font-size: 14px;
  color: #CF7F28;
  line-height: 20px;
  text-align: left;
}
</style>